/**
 * Created by tofael on 10/9/17.
 */
import React from 'react';
import DoctorForm from '../shared/doctor-form';
import globalStyles from '../../utility/styles';

const style = {
  box: {
    marginLeft: '20%',
    marginRight: '20%'
  }
};


const DoctorCreationPage = (props) => {
  return (
    <div>
      <h1 style={globalStyles.header}>Create Doctor</h1>
      <div style={style.box}>
        <DoctorForm {...props}/>
      </div>
    </div>
  )
}

export default DoctorCreationPage;


// WEBPACK FOOTER //
// ./src/screens/create-doctor/index.js